// extracted by mini-css-extract-plugin
module.exports = {"Form":"SignUpForm_Form__18Afd","FormElements":"SignUpForm_FormElements___Yg9S"};